






import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import AbpBase from "../../../lib/abpbase";
import mapLoader from "../../../lib/loadMap";
@Component
export default class aMaps extends AbpBase {
  @Prop({ type: Boolean, default: false }) value: boolean;
  map: any;
  infoWindow: any;
  Amapy: any;
  async creatMap() {
    let that = this;
    await mapLoader()
      .then(async (AMap: any) => {
        //console.log("MP加载。。then。。。", AMap);

        // if (!(window as any).AMapUI) {
        //   // 如果还没有初始化
        //   await initAMapUI(); // 这里调用initAMapUI初始化
        // }
        //加载地图
        this.map = new AMap.Map("container", {
          center: [105.612976, 38.168153],
          zoom: 4,
        });
        that.AddMarker(AMap);
        that.Amapy = AMap;
      })
      .catch((err) => {
        console.log("MP加载。。err。。。", err);
      });
  }
  // getlist() {
  //   return this.$store.state.company.list;
  // }
  //关闭信息窗体
  closeInfoWindow() {
    this.map.clearInfoWindow();
  }
  createInfoWindow(title, content) {
    var info = document.createElement("div");
    info.className = "custom-info input-card content-window-card";

    //可以通过下面的方式修改自定义窗体的宽高
    //info.style.width = "400px";
    // 定义顶部标题
    var top = document.createElement("div");
    var titleD = document.createElement("div");
    var closeX = document.createElement("img");
    top.className = "info-top";
    titleD.innerHTML = title;
    closeX.src = "https://webapi.amap.com/images/close2.gif";
    closeX.onclick = this.closeInfoWindow;

    top.appendChild(titleD);
    top.appendChild(closeX);
    info.appendChild(top);

    // 定义中部内容
    var middle = document.createElement("div");
    middle.className = "info-middle";
    middle.style.backgroundColor = "white";
    middle.innerHTML = content;
    info.appendChild(middle);

    // 定义底部内容
    var bottom = document.createElement("div");
    bottom.className = "info-bottom";
    bottom.style.position = "relative";
    bottom.style.top = "0px";
    bottom.style.margin = "0 auto";
    var sharp = document.createElement("img");
    sharp.src = "https://webapi.amap.com/images/sharp.png";
    bottom.appendChild(sharp);
    info.appendChild(bottom);
    return info;
  }

  async AddMarker(AMap) {
    //this.infoWindow = new AMap.InfoWindow({offset: new AMap.Pixel(0, -30)})
    //let list = this.getlist();
    let lnglats= await this.$store.dispatch({
      type: "thequipment/getCountHomeEchart",
    });
    let that = this;
    var markers = [];
    let i = 0;
    if (lnglats != null && lnglats.length > 0) {
      for (let entry of lnglats) {
        // 创建点实例
        var marker = new AMap.Marker({
          position: new AMap.LngLat(entry.longitude, entry.latitude),
          icon:
            "https://webapi.amap.com/theme/v1.3/markers/n/mark_b" +
            (i ) +
            ".png",
          extData: {
            id: i ,
          },
        });
        AMap.event.addListener(marker, "click", function () {
          new AMap.InfoWindow({
            isCustom: true, //使用自定义窗体
            content: that.createInfoWindow(
              entry.fname,
              "设备总数量：" +
                entry.zCount +
                "<br>低电量设备：" +
                entry.didianliangCount+
                "<br>在线设备：" +
                entry.zaixianCount +
                "<br>离线设备：:" +
                entry.lixianCount +
                "<br>"
            ),
            offset: new AMap.Pixel(16, -45),
          }).open(that.map, [entry.longitude, entry.latitude]);
        });
        markers.push(marker);
        i++;
      }
      // 创建覆盖物群组，并将 marker 传给 OverlayGroup
      var overlayGroups = new AMap.OverlayGroup(markers);
      this.map.add(overlayGroups);
      //this.map.setFitView();
    }
  }

  mounted() {}
  created() {
    this.creatMap();
  }
}
